
/**
 * @imports
 */
import init from './index.js';

/**
 * @init
 */
init.call( window );
